var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.449 5.12933C16.449 2.83693 14.8818 1.91797 12.6253 1.91797H7.32623C5.1391 1.91797 3.5 2.77428 3.5 4.97645V17.2463C3.5 17.8511 4.15079 18.2321 4.67794 17.9363L9.99624 14.9531L15.2686 17.9313C15.7966 18.2287 16.449 17.8478 16.449 17.2421V5.12933Z",
    stroke: "url(#paint0_linear_1798_40853)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89307 7.52318H12.9916",
    stroke: "url(#paint1_linear_1798_40853)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40853",
    x1: 9.97452,
    y1: 1.91797,
    x2: 9.97452,
    y2: 18.0386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D06FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A93ED7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40853",
    x1: 9.94236,
    y1: 7.10547,
    x2: 9.94236,
    y2: 7.94089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D06FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A93ED7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterIcon);
export default __webpack_public_path__ + "static/media/master-icon.f52fb3fb05f300581af03641a162db74.svg";
export { ForwardRef as ReactComponent };